<template>
    <div class="fullwidth" :class="{'widewidth':b.max}">
        <hr>
    </div>
</template>
<script>
    export default {
        name: "Fullimage",
        props: {b: Object},
    }
</script>
<style scoped lang="scss">
    .fullwidth {
        width: 100%;

    }
    .widewidth {

        padding: 0;
    }
    hr {
        border-top: 1px #b9b9b9 solid;
        margin: 0;
        margin-bottom: 10px;
    }
</style>